import { KEY_STORAGE, parseKioskKeyFromHash } from '@/lib/kiosk'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'

// Kiosk key fragment strip — MUST run before anything below (Oriflux
// analytics injection, React) can read `location.href`. The kiosk key
// arrives as `#k=<key>`; fragments are never sent over HTTP, so the only
// leak vector is a load-time JS reader of `location.href`. Stash the key
// under the same localStorage key the kiosk uses (`initKioskKey` in
// lib/kiosk.ts falls back to it) and strip the fragment synchronously,
// before the beacon below gets a chance to run.
const _kioskKey = parseKioskKeyFromHash(window.location.hash)
if (_kioskKey) {
  localStorage.setItem(KEY_STORAGE, _kioskKey)
  history.replaceState(null, '', window.location.pathname + window.location.search)
}

// Oriflux web analytics — STRICTLY OPT-IN. The key is delivered at RUNTIME by
// /oriflux-config.js (window.ORIFLUX_CONFIG), served by the backend from the
// container env — durable across redeploys (Portainer stack env), never baked
// into the build. Empty/absent key = loader stays inert.
const _ofx = (window as unknown as {
  ORIFLUX_CONFIG?: { key?: string; endpoint?: string }
}).ORIFLUX_CONFIG
if (_ofx && _ofx.key) {
  const _s = document.createElement('script'); _s.defer = true
  const _ep = _ofx.endpoint || 'https://in.oriflux.sponge-theory.dev'
  _s.src = `${_ep}/v1/oriflux.js`; _s.setAttribute('data-key', _ofx.key)
  _s.setAttribute('data-endpoint', _ep); document.head.appendChild(_s)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
